import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "@src/utils/baseQuery";
import { APIResponse } from "./CommonApiSlice";

interface AddSubTopicPayload {
  name: string;
  duration: number;
  description: string | undefined;
}

export interface SubTopicItem {
  createdOn: string;
  lastUpdateOn: string;
  createdByName: string;
  createdByEmail: string;
  modifiedByName: string;
  modifiedByEmail: string;
  id: string;
  _id: string;
  name: string;
  duration: number;
  topicId: string;
  description: string;
  weight: number;
  type: string;
  parentId: string;
  searchKey: string;
}

export interface GetAllSubtopicsForTopic extends APIResponse {
  response: SubTopicItem[];
}

export type AddSubTopicRespons = APIResponse;

export type UpdateSubTopicResponse = APIResponse;

export type GetSubTopicOfMultipleTopicsResponse = GetAllSubtopicsForTopic;

export interface UpdateSubTopicDurationPayload {
  resourceId: string;
  resourceType: string;
  totalDuration?: number;
  completedDuration?: number;
  status?: boolean;
  videoStatus?: boolean;
  batchRef: string;
  notes?: string;
  [key: string]: any;
}
export interface AddVideoDataPayload {
  parentIds: string[];
  isVideoPresent: boolean;
}

export const SubTopicApiSlice = createApi({
  reducerPath: "subtopicApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAllSubTopics: builder.query<
      GetAllSubtopicsForTopic,
      { topicId: string }
    >({
      query: ({ topicId }) => ({
        url: `sub-topic?topicId=${topicId}`,
        method: "GET",
      }),
    }),
    addSubTopics: builder.mutation<
      AddSubTopicRespons,
      { payload: AddSubTopicPayload; parentId: string; parentType: string }
    >({
      query: ({ parentId, parentType, payload }) => ({
        url: `sub-topic?parentId=${parentId}&parentType=${parentType}`,
        method: "POST",
        body: payload,
      }),
    }),
    getSubTopicsofMultipleTopics: builder.mutation<
      GetSubTopicOfMultipleTopicsResponse,
      string[]
    >({
      query: (topicIds) => ({
        url: `sub-topic/get`,
        method: "POST",
        body: topicIds,
      }),
    }),
    updateSubTopic: builder.mutation<
      UpdateSubTopicResponse,
      { subTopicId: string; payload: { [key: string]: string } }
    >({
      query: ({ subTopicId, payload }) => ({
        url: `sub-topic?subTopicId=${subTopicId}`,
        method: "PUT",
        body: payload,
      }),
    }),
    updateSubTopicDuration: builder.mutation<
      UpdateSubTopicResponse,
      UpdateSubTopicDurationPayload
    >({
      query: (payload) => ({
        url: `student/add-student-resourceData`,
        method: "POST",
        body: payload,
      }),
    }),
    addSubTopicVideoData: builder.mutation<
      UpdateSubTopicResponse,
      AddVideoDataPayload
    >({
      query: (payload) => ({
        url: `sub-topic/add-videoData`,
        method: "PATCH",
        body: payload,
      }),
    }),
    addVideoData: builder.mutation<APIResponse, AddVideoDataPayload>({
      query: (payload) => ({
        url: `sub-topic/add-videoData`,
        method: "PATCH",
        body: payload,
      }),
    }),
  }),
});

export const {
  useAddSubTopicsMutation,
  useAddSubTopicVideoDataMutation,
  useGetSubTopicsofMultipleTopicsMutation,
  useUpdateSubTopicMutation,
  useAddVideoDataMutation,
  useUpdateSubTopicDurationMutation,
  useLazyGetAllSubTopicsQuery,
} = SubTopicApiSlice;
